import React from "react";
import Icon from "components/AppIcon";

const ContinueButton = ({ disabled, loading, onClick }) => {
  return (
    <div className="text-center">
      <button
        onClick={onClick}
        disabled={disabled || loading}
        className={`btn-primary px-8 py-3 text-base font-medium min-w-48 ${
          disabled && !loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        {loading ? (
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Initializing Store...</span>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <span>Continue to Products</span>
            <Icon name="ArrowRight" size={20} />
          </div>
        )}
      </button>

      {disabled && !loading && (
        <p className="text-sm text-text-secondary mt-2">
          Please select a store to continue
        </p>
      )}
    </div>
  );
};

export default ContinueButton;
